<template>
	<div>

		<b-row class="mt-3">
			<b-col md="12">
				<b-link
					:to="{ name: 'register' }"
					class="float-right  mb-3"
					title="Create new user"
				>
					<b-icon font-scale="1.5" icon="plus-square"></b-icon>
				</b-link>

			</b-col>

		</b-row>

		<b-row class="mt-3">

			<b-col md="12">

				<b-table-simple bordered>

					<b-thead head-variant="light">
						<tr>							
							<th>Name</th>
							<th>Email</th>
							<th>Phone</th>					
						</tr>
					</b-thead>
					<b-tbody>
						<user-list-row
							v-for="user in users"
							:key="user.Id"
							:user="user"
							@update="updateUser"		
						/>
					</b-tbody>

				</b-table-simple>

			</b-col>

		</b-row>

	
	</div>
</template>


<script>
import UserService from "@/api-services/account.service";
import UserListRow from "@/components/account/user-list-row";

export default {
	name: "UserList",

	components: {
		UserListRow
	},

	data() {
		return {
			users: [],
			
		};
	},

	created() {
		this.fetchUsers();
	},

	methods: {
		detailsUser(userId) {
			this.$router.push({
				name: "userdetails",
				params: { id: userId }
			});
		},
		updateUser(userId) {
			this.$router.push({
				name: "userupdate",
				params: { id: userId }
			});
		},
		
		fetchUsers() {
			UserService.getAll().then(response => {
				this.users = response.data;
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/account/user-list.vue